import { PageLoadingWrapper } from './PageLoadingStyle';
import loaderGif from '../../../../assets/images/banner.gif';

const PageLoading = () => {
  return (
    <PageLoadingWrapper>
      <img src={loaderGif} alt="loading" />
    </PageLoadingWrapper>
  )
}

export default PageLoading